@import 'styles/mixins';
@import 'styles/variables';

.actions {
  display: flex;
  flex: 1;
  justify-content: flex-end;

  .disabled {
    opacity: 0.3;
  }

  .reject {
    &:hover {
      background: $red-10;
    }

    &:active {
      background: $red-20;
    }
  }

  .accept {
    &:hover {
      background: $green-10;
    }

    &:active {
      background: $green-20;
    }
  }
}
